import { all } from 'redux-saga/effects';
import watchAuth from './watcher';
import { watchCharges } from './charges';

export default function* rootSaga() {
	yield all([watchAuth(), watchCharges()]);
}
